// src/App.js
import React, { useState } from 'react';
import UserForm from './components/UserForm';
import DestinationResults from './components/DestinationResults';
import { destinations } from './data/destinations';
import { matchDestinations } from './utils/matchAlgorithm';

// Optional n8n webhook. The app works without it: if the variable is not set,
// we simply skip the call instead of failing on every submission.
const N8N_WEBHOOK_URL = process.env.REACT_APP_N8N_WEBHOOK_URL;

function App() {
  const [users, setUsers] = useState([]);
  const [results, setResults] = useState([]);

  const handleAddUser = (user) => {
    const updatedUsers = [...users, user];
    setUsers(updatedUsers);

    if (N8N_WEBHOOK_URL) {
      console.log('🟡 Sending data to n8n...', user);

      fetch(N8N_WEBHOOK_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(user),
      })
        .then(response => {
          console.log('📦 Response received:', response);
          if (!response.ok) {
            console.error('❌ Error sending to n8n:', response.statusText);
          } else {
            console.log('✅ User sent to n8n');
          }
        })
        .catch(error => {
          console.error('❌ Connection error with n8n:', error);
        });
    }

    if (updatedUsers.length >= 2) {
      const matched = matchDestinations(updatedUsers, destinations);
      setResults(matched);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>Find the perfect destination 🧳</h1>
      <UserForm onSubmit={handleAddUser} />

      {users.length > 0 && (
        <div>
          <h2>Users added</h2>
          <ul>
            {users.map((u, index) => (
              <li key={index}>
                <strong>{u.name}</strong> from <strong>{u.city}</strong>, budget: {u.budget}€<br />
                Interests: {u.interests.join(', ')}<br />
                {u.nightlife && 'Enjoys nightlife · '}
                {u.environment && `Prefers ${u.environment} · `}
                {u.explorer && 'Wants to discover new experiences · '}
                {u.favorites && `Favorite shows/movies: ${u.favorites}`}
              </li>
            ))}
          </ul>
        </div>
      )}

      {results.length > 0 && <DestinationResults destinations={results} />}
    </div>
  );
}

export default App;
